import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Listing } from 'models/Listing';
import { Link } from 'react-router-dom';
import { Button } from 'ncoded-component-library';
import utils from 'utils';
import ListingLocation from 'components/ListingLocation';
import ListingPrices from 'components/ListingPrices';
import ListingCardThumbnail from 'components/ListingCardThumbnail';

import './MessageListingPreview.styles.scss';
import './MessageListingPreview.styles.responsive.scss';

type MessageListingPreviewProps = {
  className?: string;
  listing: Partial<Listing>;
};

const MessageListingPreview: React.FC<MessageListingPreviewProps> = (props) => {
  const { className, listing } = props;

  const classes = classNames('message-listing-preview', className);

  const {
    listingTitle,
    location,
    dealLocation,
    industry,
    gallery,
    slugName,
    type,
    businessDescription,
    askingPriceSelect,
    amount,
    amountFrom,
    amountTo,
    revenue,
    EBITDA,
    averageStockValue,
    stockAtValue,
    currency,
    amountRequiredVisibleInfo,
    amountFromRequiredVisibleInfo,
    amountToRequiredVisibleInfo,
    revenueRequiredVisibleInfo,
    EBITDARequiredVisibleInfo,
    averageStockValueRequiredVisibleInfo,
  } = listing || {};

  const { t } = useTranslation();

  const redirectionListingLink = utils.composeBusinessUrl(
    industry,
    slugName,
    type,
  );

  return (
    <Link className={classes} to={redirectionListingLink}>
      <div className="message-listing-preview__content">
        <div className="message-listing-preview__content__title">
          {listingTitle}
        </div>
        <ListingLocation
          industry={industry}
          location={location}
          dealLocation={dealLocation}
        />
        <ListingPrices
          askingPrice={askingPriceSelect}
          amount={amount}
          amountFrom={amountFrom}
          amountTo={amountTo}
          revenue={revenue}
          EBITDA={EBITDA}
          averageStockValue={averageStockValue}
          stockAtValue={stockAtValue}
          currency={currency}
          amountRequiredVisibleInfo={amountRequiredVisibleInfo}
          amountFromRequiredVisibleInfo={amountFromRequiredVisibleInfo}
          amountToRequiredVisibleInfo={amountToRequiredVisibleInfo}
          revenueRequiredVisibleInfo={revenueRequiredVisibleInfo}
          EBITDARequiredVisibleInfo={EBITDARequiredVisibleInfo}
          averageStockValueRequiredVisibleInfo={
            averageStockValueRequiredVisibleInfo
          }
        />
        <div className="message-listing-preview__content__description">
          {businessDescription}
        </div>
      </div>
      <div className="message-listing-preview__gallery">
        <ListingCardThumbnail gallery={gallery} />
        <Button variant="outline">{t('goToListing')}</Button>
      </div>
    </Link>
  );
};

export default MessageListingPreview;
